import State from '@/helpers/pattern/state';
import {SeguimientoControlModel} from "@/models/seguimiento/scheduled/seguimiento-control";
import {modelIsModified} from "@/helpers/vue-mc";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import SeguimientoAPI from "@/services/seguimiento/scheduled";
import {scrollToForm} from '@/helpers/form-scroll-to';
import moment from 'moment';
import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
import ParametrosAPI from "@/services/generales/parametros";

/**
 * State Pattern for Comercio form
 */
export default class SeguimientoControlScheduledStates extends State{
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */
  constructor(data){
    super(data);
  }

  /**
   * General Methods
   */
  base(){
    return {
      clear({$setState}){
        $setState('initial');
      }
      , resetModel({$data}){
        $data.seguimientoControl = new SeguimientoControlModel();
      }
      , resetValidators({$data}){
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({$data}){
        return $data.hasErrors($data.$v.seguimientoControl) || $data.view.action.submit.busy;
      }
      , getDataSerieChart({$data},proceso,bitacora){
        return {
          meta:`${proceso.name} 
          , Fecha Inicio = ${$data.view.tools.dateMethods.formatDateTime(bitacora.fechaInicio)} 
          , Fecha Fin = ${$data.view.tools.dateMethods.formatDateTime(bitacora.fechaFin)} 
          , ${bitacora.detalle|| ''} `
          , x:new Date(bitacora.fechaInicio)
          , y: moment(`${bitacora.horaInicio}`.padStart(6,'0'), 'HHmmss')}
      }
      , getDataChart({$data}, respuesta){
        if(respuesta.dtr){
          $data.view.elem.table.data = respuesta.dtr;
          
          let dtrOrigin = respuesta.dtr;
          $data.chartData.series = [];
          let serieExtemporanea = [];
          for (let proceso of $data.view.elem.select.procesos.options) {
            let isExtemporanea = false
            for (let tipoEjecucion of $data.view.elem.select.tipoEjecucion.options) {
              let filtersBitacora =  dtrOrigin.filter(bitacora => (bitacora.proceso === proceso.code && bitacora.tipoEjecucion === tipoEjecucion.code));
              let dataChart = []
              for(let bitacora of filtersBitacora){
                let dataserie = this.getDataSerieChart(proceso,bitacora)
                if ((bitacora.interfaz === "EXTEMPORANEA"))
                  serieExtemporanea.push(dataserie)
                else 
                  dataChart.push(dataserie)
              }
              if(dataChart.length > 0){
                // let interfazEjecucion = proceso.code == 'DOWNLOADER' ? "-"+proceso.interfaz : '';
                let className =`${proceso.code}-${tipoEjecucion.code}`
                let serie = {name: proceso.name, data:dataChart, className}
                $data.chartData.series.push(serie);
                
              }
              if(serieExtemporanea.length > 0){
                $data.chartData.series.push({name: `Downloader-Extemporanea`, data:serieExtemporanea, className:`DOWNLOADER-EXTEMPORANEA`});
              }
              
            }
          }
          try{
            const claveParametro = 1;
            this.setAxisX(claveParametro);
            
          }catch(error){
            console.error()
          }
          
         
          $data.view.elem.chart.showMessage = !($data.chartData.series.length > 0);
        }
      }
      , async setAxisX({$data},idParametros){
        try{
          const response = await ParametrosAPI.get({clave:idParametros});
          const {data:{results:{parametros}}} = response;
          $data.chartOptions.axisX.divisor = parametros.dias
          
        }catch(error){
          console.error(error)
        }
      }
      , async getLog({$data},proceso){
        try{
          const response = await SeguimientoAPI.getLog(proceso);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.headers.filename); //or any other extension
          document.body.appendChild(link);
          link.click();
          
        }catch(error){
          console.error(error)
        }
      }
    }
  }

  /**
   * States and its methods
   */
  states(){
    return{
      initial:{
        $constructor:function({$data}){
          //Reset Models and validators
          this.resetModel();
          this.resetValidators();
          //View configuration
          // $data.view.elem.button.clear.visible=true;
          // $data.view.elem.button.audit.visible=false;
          // $data.view.elem.input.clave.visible=false;
          // $data.view.elem.input.clave.disabled=true;
          // $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          // $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.save;
          
          
        }
        , async submit({$data},{
          fecha
          , tipoProceso
          , tipoEjecucion
        }){
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data);
              return false;
            }

            let codeProceso = tipoProceso != undefined ? tipoProceso.code : ''
            let codeEjecucion= tipoEjecucion != undefined ? tipoEjecucion.code : ''
            $data.view.action.submit.busy=true;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
            const response = await SeguimientoAPI.get({fecha , tipoProceso:codeProceso , tipoEjecucion:codeEjecucion})
            $data.view.action.submit.busy=false;
            // this.resetModel();
            this.resetValidators();
            // $data.$refs.comercioTable.refreshData();
            const responseDTO = getResponseDTO(response);
            // handleResponseMessage({response: response,modulo:$data.name});
            this.getDataChart(responseDTO);
            return responseDTO;
          }catch(error){
            console.log(error)
            return error;
          }finally{
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/seguimiento/scheduled/seguimiento-control-scheduled-states.js